import { createSelector } from 'reselect';
import { getAllsureHomeClaim } from './index';

export const getBasicDetailsDetails = createSelector(
    getAllsureHomeClaim,
    (allsureHomeClaim) => allsureHomeClaim.basicDetails
);

export const getBasicDetailsForm = createSelector(
    getBasicDetailsDetails,
    (basicDetails) => basicDetails.form
);
export const getSelectedCategoryType = createSelector(
    getBasicDetailsForm,
    (basicDetailsForm) => basicDetailsForm.categoryType.value
);



